import { Row } from "antd";
import SearchCategories from "../SearchCategories";
import "./DisplayBanner.scss";
//import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";

export default function DisplayBanner() {
  const member = useRecoilValue(memberState);
  /*const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  const bannerContent = [
    { subtitle: "The #1 Digital Menu Display for Restaurants", ctaText: "Buy Now", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner1.webp", index: 1 },
    { subtitle: "Digital Menu Boards Made Simple", ctaText: "Buy Now", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner2.webp", index: 2 },
    { subtitle: "The Easiest Way to Launch Digital Display Menus", ctaText: "Buy Now", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner3.webp", index: 3 },
    { subtitle: "Put Your Menus on Any TV—Instantly", ctaText: "Grab One", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner4.webp", index: 4 },
    { subtitle: "Your Menu, On-Screen. No Design Skills Needed", ctaText: "Grab One", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner5.webp", index: 5 },
    { subtitle: "Turn Any Screen into a Pro-Grade Menu Display", ctaText: "Grab One", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner6.webp", index: 6 },
    { subtitle: "Upgrade to Digital Display Menus in Minutes", ctaText: "Add To Cart", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner1.webp", index: 7 },
    { subtitle: "Modern Menu Displays Without the Tech Hassle", ctaText: "Add To Cart", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner1.webp", index: 8 },
    { subtitle: "Sell More with Professional Digital Display Menus", ctaText: "Add To Cart", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner1.webp", index: 9 },
    { subtitle: "From Static to Stunning—Digital Display Menus That Work", ctaText: "Add To Cart", imageUrl: "https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner7.webp", index: 10 },
  ];

  useEffect(() => {
    // Get the stored index from localStorage or default to -1
    const storedIndex = parseInt(localStorage.getItem('displayBannerIndex') || '-1');

    // Calculate next index, wrapping around to 0 if we reach the end
    const nextIndex = (storedIndex + 1) % bannerContent.length;

    // Store the new index and update state
    localStorage.setItem('displayBannerIndex', nextIndex.toString());
    setCurrentBannerIndex(nextIndex);
  }, [bannerContent.length]);*/

  /*const [availableDevices, setAvailableDevices] = useState(0);
  const [deactivatedDevices, setDeactivatedDevices] = useState(0);
  const [screens, setScreens] = useState([] as ScreenView[]);
  const [totalScreensAndLicenses, setTotalScreensAndLicenses] = useState(0);
  const [loading, setLoading] = useState(true);
  const [devicesLoading, setDevicesLoading] = useState(true);
  const [availableDevicesLoading, setAvailableDevicesLoading] = useState(true);
  const [deactivatedDevicesLoading, setDeactivatedDevicesLoading] = useState(true);

  const fetchDevices = useCallback(() => {
    setDevicesLoading(true);
    DSAApi.getScreens().then(r => {
      let screens = r.data as ScreenView[];
      setScreens([...screens]);
      setDevicesLoading(false);
    }).catch(e => {
      handleServerError(e, "Failed to fetch devices.");
      setDevicesLoading(false);
    });
  }, []);

  const fetchAvailableDevices = useCallback(() => {
    setAvailableDevicesLoading(true);
    DSAApi.getScreensTotal().then(r => {
      setAvailableDevices(r.data);
      setAvailableDevicesLoading(false);
    }).catch(e => {
      handleServerError(e, "Failed to fetch available devices.");
      setAvailableDevicesLoading(false);
    });
  }, []);

  const fetchDeactivatedDevices = useCallback(() => {
    setDeactivatedDevicesLoading(true);
    DSAApi.getDeactivatedScreensTotal().then(r => {
      setDeactivatedDevices(r.data);
      setDeactivatedDevicesLoading(false);
    }).catch(e => {
      handleServerError(e, "Failed to fetch deactivated devices.");
      setDeactivatedDevicesLoading(false);
    });
  }, []);

  useEffect(fetchDevices, [fetchDevices]);
  useEffect(fetchAvailableDevices, [fetchAvailableDevices]);
  useEffect(fetchDeactivatedDevices, [fetchDeactivatedDevices]);

  useEffect(() => {
    setTotalScreensAndLicenses(screens.length + availableDevices + deactivatedDevices);
  }, [screens.length, availableDevices, deactivatedDevices]);

  useEffect(() => {
    setLoading(devicesLoading || availableDevicesLoading || deactivatedDevicesLoading);
  }, [devicesLoading, availableDevicesLoading, deactivatedDevicesLoading])*/

  return (
    <Row>
      <div className={`home-banner dsab`}>
        <div className="mobile-search-cats">
          <SearchCategories />
        </div>

        <div className={`dsa-banner`}>
          {/*loading ? <></>
          :
          member.plan !== MemberDtoPlanEnum.Free && totalScreensAndLicenses === 0 ?
          <>
            <div className="left-section">
              <div className="count-down"></div>
              <div className="text-stacked">
                <div>SALE: DIGITAL MENU BOARD DISPLAYS</div>
                <div>Free Migration & Onboarding + Free Pro Month. <a href="/feature/display-spring-sale.html" target="_blank">Learn more...</a></div>
              </div>
            </div>
            <div className="right-section">
              <a className="ant-btn ant-btn-lg ant-btn-primary" href="https://musthavemenus.online/display-spring-sale-banner-order" target="_blank"
                rel="noreferrer">Order Now</a>
              <img src="https://timber.mhmcdn.com/site/feature/dsa-feature/Hero.webp" alt="display hero"/>
            </div>
          </>
          :*/}
          <div className="left-section">
            <div className="img-cont">
              <img src={"https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DisplayBanner/DisplayBanner1.webp"} alt="display"/>
            </div>
            <div className="text-stacked">
              <div>We'll Price Match Your Current Display Provider.</div>
              <div>Switch to MustHaveMenus Digital Menu Board Display and manage everything in one platform.</div>
            </div>
          </div>
          <div className="right-section">
            {!member.viewOnly &&
              <a href="https://support-musthavemenus.zohobookings.com/#/4507337000004098028"
              className="ant-btn ant-btn-lg buy-now"
              >
                SWITCH NOW
              </a>
            }
            <a href="https://musthavemenus.online/jnd" target="_blank"
              rel="noreferrer">Learn More</a>
          </div>
        </div>
      </div>
    </Row>
  );
}
